// extracted by mini-css-extract-plugin
export default {"container":"order-tape-card_container__FoGAK","spaceBetween":"order-tape-card_spaceBetween__OD-M9","statusDone":"order-tape-card_statusDone__F7SNd"};